// extracted by mini-css-extract-plugin
export default {"container":"eBGYjq","triangle":"OSuTcH","right":"AlV3m5","left":"I15DQJ","bottom":"rUW3EN"};